<template>
  <div class="dateTimeWrapper">
    <div class="containerWrapper">
      <div class="dateContainer">
        <DatePicker
          ref="datePickerRef"
          :start-date="innerStartDate"
          :end-date="innerEndDate"
          :single-date="singleDate"
          @onChange="__onChange"
        />
      </div>
      <div class="timeContainer">
        <div class="startTime timeRow">
          <span
            v-show="!singleDate"
            class="subTitle"
          >From</span>
          <div>
            <span class="bigNumber">{{ innerStartDate || new Date() | moment("DD") }}</span>
            {{ innerStartDate || new Date() | moment("MMM YYYY") }}
          </div>
        </div>
        <div
          v-if="!singleDate"
          class="endTime timeRow"
        >
          <span class="subTitle">To</span>
          <div>
            <span class="bigNumber">{{ innerEndDate || new Date() | moment("DD") }}</span>
            {{ innerEndDate || new Date() | moment("MMM YYYY") }}
          </div>
        </div>
      </div>
    </div>
    <div class="buttonWrap">
      <div class="row justify-content-end">
        <div class="col-3">
          <button-wrapper
            size="fill"
            color="pink"
            @click.prevent="__onCancel"
          >
            取消
          </button-wrapper>
        </div>
        <div class="col-3">
          <button-wrapper
            size="fill"
            @click.prevent="__onSubmit"
          >
            確定
          </button-wrapper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DatePicker } from '@lazy-copilot/datetimepicker'
import ButtonWrapper from '~components/common/buttons'

export default {
  name: 'DatePickerModal',
  components: {
    DatePicker,
    ButtonWrapper
  },
  props: {
    startDate: {
      type: Date,
      required: true
    },
    endDate: {
      type: Date,
      default: null
    },
    singleDate: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      innerStartDate: this.startDate,
      innerEndDate: this.endDate
    }
  },
  methods: {
    __onCancel () {
      this.$emit('cancel')
    },
    __onChange (data) {
      return this.singleDate
        ? this._onChangeSingleDate(data)
        : this._onChangeMultiDate(data)
    },
    _onChangeMultiDate (data) {
      const { startDate, endDate } = data
      this.innerStartDate = startDate
      this.innerEndDate = endDate
    },
    _onChangeSingleDate (data) {
      const { startDate } = data
      this.innerStartDate = startDate
    },
    __onSubmit () {
      return this.singleDate
        ? this._submitSingleHandler()
        : this._submitMultiHandler()
    },
    _submitSingleHandler () {
      this.$emit('submit', {
        startDate: this.innerStartDate
      })
    },
    _submitMultiHandler () {
      this.$emit('submit', {
        startDate: this.innerStartDate,
        endDate: this.innerEndDate
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.dateTimeWrapper {
  max-width: 768px;
  background: #fff;
  box-shadow: 0 20px 50px rgba(183, 185, 188, 0.35);
  .containerWrapper {
    display: flex;
    padding: 20px 0;
    .dateContainer {
      padding: 0 30px;
      border-right: 1px solid $light;
    }
    .timeContainer {
      padding: 0 30px;
      .timeRow {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding: 15px 0;
        min-width: 65px;
        .subTitle {
          font-size: 13px;
          color: $muted;
        }
        .bigNumber {
          font-size: 34px;
          letter-spacing: 3px;
          line-height: 45px;
          color: $primary;
          font-weight: 100;
        }
      }
    }
  }
  .buttonWrap {
    padding: 20px;
    width: 100%;
    border-top: 1px solid $light;
    .confirm {
        color: #fff;
        background: $primary;
      }
    .cancel {
      color: $muted;
    }
  }
}
@media only screen and (max-width: 700px) {
  .dateTimeWrapper {
    width: 100%;
    .containerWrapper {
      display: block;
      .dateContainer {
        margin-bottom: 40px;
        border-right: none;
        .datePicker_wrap {
          ul.calendar {
            li {
              width: 70px;
            }
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 480px) {
  .dateTimeWrapper {
    .containerWrapper {
      .dateContainer,
      .timeContainer {
        padding: 0;
        .timeRow {
          padding: 8px 0;
        }
      }
    }
    .buttonWrap {
      padding: 20px 30px 30px 0;
    }
  }
}
</style>
